import { render, staticRenderFns } from "./HiwAccordionItems.vue?vue&type=template&id=6a3c8d5e&scoped=true&"
import script from "./HiwAccordionItems.vue?vue&type=script&lang=js&"
export * from "./HiwAccordionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c8d5e",
  null
  
)

export default component.exports